import { CustomMarkdownRenderer } from 'components/index'
import React from 'react'

type ContentBodyProps = {
  content: string
  children?: React.ReactNode
}
export const ContentBody = ({ children, content }: ContentBodyProps) => {
  return (
    <div>
      <CustomMarkdownRenderer details={content} options={{ html: true }} />
      {children}
    </div>
  )
}
